import { FC, useState, useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import AboutUs from '../components/AboutUs';
import Projects from '../components/Projects';
import BeforeAfterProjects from '../components/BeforeAfterProjects';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { contentService, SiteContent } from '../services/contentService';

const HomePage: FC = () => {
  const [siteContent, setSiteContent] = useState<SiteContent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const content = await contentService.getContent();
        setSiteContent(content);
      } catch (error) {
        console.error('Error loading site content:', error);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <SEO 
        title={siteContent?.seo?.title || "Aluxim | Ogrody zimowe, zabudowy tarasów i balkonów"}
        description={siteContent?.seo?.description || "Profesjonalne ogrody zimowe, zabudowy tarasów i balkonów. Nowoczesne rozwiązania dla Twojego domu od firmy Aluxim z wieloletnim doświadczeniem."}
        keywords={siteContent?.seo?.keywords || "ogrody zimowe, zabudowy tarasów, zabudowy balkonów, system bezramowy, zadaszenia tarasów, daszki, najwyższa jakość"}
        ogImage={siteContent?.seo?.ogImage}
      />
      <Hero content={siteContent?.hero} />
      <Services content={siteContent?.services} />
      <AboutUs content={siteContent?.about} />
      <Projects />
      <BeforeAfterProjects />
      <Contact content={siteContent?.contact} />
      <Footer content={siteContent?.footer} />
    </div>
  );
};

export default HomePage;
